import { FORMAT_DATE } from 'common/constants';
import { memoize, set } from 'lodash';
import moment from 'moment';
import { Status } from './typed';

export const getRequestVisibile: (
  activeKey: Status | undefined,
  list: Status[],
) => {
  Done: Status[];
  Pending: Status[];
  Waiting: Status[];
} = (activeKey, list) => {
  if (!activeKey) {
    return {
      Done: [],
      Pending: [],
      Waiting: list,
    };
  }
  if (activeKey === 'CLOSED') {
    return {
      Done: list,
      Pending: [],
      Waiting: [],
    };
  }
  const index = list.indexOf(activeKey);
  return {
    Done: list.slice(0, index),
    Pending: [activeKey],
    Waiting: list.slice(index + 1, list.length),
  };
};

export const correctData = memoize((data: any) => {
  const result: { [name: string]: any } = {};
  Object.keys(data).forEach(key => {
    if (data[key] instanceof Array) {
      result[key] = data[key]?.filter(
        (item: any) => !item?.hasOwnProperty('temp'),
      );
    } else if (moment.isMoment(data[key])) {
      result[key] = moment(data[key]).format(FORMAT_DATE.FULL_DATETIME);
    } else if (data[key] instanceof Object) {
      result[key] = correctData(data[key]);
    } else {
      result[key] = data[key];
    }
  });
  return result;
});

export const getDateCorrect = (value: any) => {
  return moment.isMoment(value)
    ? value
    : moment(value, FORMAT_DATE.FULL_DATETIME);
};

export const resetDate = (action: any, state: any) => {
  const siteVisitDate = action?.getFieldValue('siteVisitDate');
  const startDate = action?.getFieldValue('startDate');
  const endDate = action?.getFieldValue('endDate');
  if (
    state === 'EDIT' &&
    getDateCorrect(siteVisitDate).isBefore(getDateCorrect(moment()), 'day')
  ) {
    action?.setFieldsValue({
      siteVisitDate: moment(
        `${moment().format(FORMAT_DATE.SHORT_MONTH_DATE)} 08:00 AM`,
      ),
    });
  }
  if (
    state === 'EDIT' &&
    getDateCorrect(endDate).isBefore(getDateCorrect(moment()), 'day')
  ) {
    action?.setFieldsValue({
      endDate: undefined,
    });
  }
  if (
    state === 'EDIT' &&
    getDateCorrect(startDate).isBefore(getDateCorrect(moment()), 'day')
  ) {
    action?.setFieldsValue({
      startDate: undefined,
    });
  }
};

export const numberWithCommas = (number: number | undefined) => {
  return number && number.toLocaleString();
};

export const handleMaxAutoComplete = (value: any, maxLength: any) => {
  if (value?.length <= maxLength) {
    return value;
  } else {
    return value?.substring(0, maxLength);
  }
};
